export const getFormattedDate = (date) => {
  let year = date.getFullYear();
  let month = (1 + date.getMonth()).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  let time = date.getHours() + ':' + date.getMinutes();

  return day + '.' + month + '.' + year + ' kl. ' + time;
};

export const getDateFromSeconds = (seconds) => {
  return new Date(seconds * 1000).toLocaleString().slice(0, -3);
};
